import qs from 'qs'

export default function getWidgetsOrigin() {
    const { origin } = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    return origin
}